module.exports = __webpack_public_path__ + "img/20191113160823360截图20191113155641034.5b24a8b8.jpg";